import React from 'react'
import { useStep1Props } from './types'
import useStep1 from './hooks/useStep1'
import { wrap } from '../../../utils/globalUtils'
import Step1View from './views/Step1View'

const Step1: React.FC<useStep1Props> = wrap(Step1View, useStep1)
export default Step1
